export default "__VITE_ASSET__LiJGc8vz__"